import { Injectable, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';
import { CareTypeTerms, DisplayFilterTerms, FilterTerms, FilterTypes, SortTypes } from '../../models/FIlterTerms';
import { SearchObjectService } from '../../services/search-object.service';

@Injectable({
  providedIn: 'root'
})
export class FilterNavigationService {

  filterData = <any>{};
  filters = [];
  filtersDisplay = [];
  filtersAvailableChange: Subject<boolean> = new Subject<boolean>();
  // FilterTerms.lgbtqia,
  private filterOrder = [FilterTerms.sortType, FilterTerms.acceptingNewPatients, FilterTerms.subProductKey, FilterTerms.onlineScheduling, 
    FilterTerms.peopleplaces, FilterTerms.gender, FilterTerms.language, FilterTerms.handicapAccess, FilterTerms.opentime,
    FilterTerms.hospitalPrivilege, FilterTerms.telehealth, FilterTerms.accreditedFacility];

  constructor(private searchObjectService: SearchObjectService) {
  }

  serviceFilters(data) {
    const searchType = this.searchObjectService.getSearchObject().loginType;

    this.filterData = data;

    // determine which filters to get based on search results/search object
    // (force move to more, prevent deselection)
    this.filters = [];

    // filters for all search types
    if (this.searchObjectService.getProviderName()) {
      this.createSortFilter(false, true);
    }

    this.createOpenTimesFilter(false, false);

    if (!this.searchObjectService.isCigna()) {
      if ([CareTypeTerms.Medical, CareTypeTerms.BehavioralHealth].includes(this.searchObjectService.getCareType())) {
        this.createTeleHealthFilter(false, false);
      } 
      if (!searchType) {
        // pharmacy medicare hardcode
        if (this.searchObjectService.getNetworkID() === '0000010000010001600004') {
          this.createPlansAcceptedFilter(false, true);
        } else {
          this.createPlansAcceptedFilter(false, false);
        }
      }
      if (this.searchObjectService.getCareType() !== CareTypeTerms.Pharmacy) {
        this.createHandicapFilter(false, false);
      }
    }

    if (this.searchObjectService.getSearchTypeFilter() === FilterTerms.Both) {     // filters for both practitioner and facility results
      if (this.searchObjectService.getCareType() === CareTypeTerms.Medical) {
        // this.createLGBTQIAFilter(false, false);
      }
      this.createGenderFilter(false, false);
      this.createAcceptingFilter(false, false);
      this.createPeoplePlacesFilter(false, false);
      if (!this.searchObjectService.isCigna()) {
        if (this.searchObjectService.getCareType() !== CareTypeTerms.Pharmacy) {
          this.createAccredFilter(false, false);
        }
        this.createHospitalPrivilegeFilter(false, false);
      }
      this.createLanguageFilter(false, false);
    } else if (this.searchObjectService.getSearchTypeFilter() === FilterTerms.Practitioner) {       // filters for practitioner only results
      if (this.searchObjectService.getCareType() === CareTypeTerms.Medical) {
        // this.createLGBTQIAFilter(false, false);
      }
      this.createGenderFilter(false, false);
      this.createAcceptingFilter(false, false);

      if (!this.searchObjectService.isCigna()) {
        this.createHospitalPrivilegeFilter(false, false);
      }
      this.createLanguageFilter(false, false);
    } else if (this.searchObjectService.getSearchTypeFilter() === FilterTerms.Facility) {      // filters for facility only results
      if (!this.searchObjectService.isCigna()) {
        if (this.searchObjectService.getCareType() !== CareTypeTerms.Pharmacy) {
          this.createAccredFilter(false, false);
        }
      }
    }

    this.filtersAvailableChange.next(null);

  }

  getFilters() {
    //this.filtersDisplay = JSON.parse(JSON.stringify(this.filters));
    this.filtersDisplay = Object.assign([], this.filters);
    return this.filtersDisplay;
  }

  getSelected() {
    return this.filters.some(filter => filter.checked || filter.selected);
  }

  getSelectedNoDeselect() {
    return this.filters.some(filter => (filter.checked || filter.selected) && !filter.prevDes);
  }

  getSelectedLength() {
    let size = 0;
    this.filters.forEach(filter => {
      if (filter.type === FilterTypes.checkboxlist) {
        filter.ddData.forEach(ddData => {
          if (ddData.Checked) {
            size++;
          }
        });
      } else {
        if (filter.checked || filter.selected) {
          size++;
        }
      }

    });
    return size;
  }

  checkSelectedExists(selected: string, ddData: DDData[]) {
    return ddData.some(function(d) {
      return d.Key === selected;
    });
  }

  updateFilters(searchType) {
    //this.filters = JSON.parse(JSON.stringify(this.filtersDisplay));
    this.filters = Object.assign([], this.filtersDisplay);
    const filterObj = [];
    for (const filter of this.filters) {
      if (filter.type === FilterTypes.checkboxlist) {
        for (const option of filter.ddData) {
          const f = {
            name: option.Key,
            value: option.Checked
          };
          filterObj.push(f);
        }
      } else if (filter.name === FilterTerms.subProductKey) {
        const f = {
          name: filter.name,
          displayKey: filter.selected !== 'undefined' && filter.selected !== undefined ? filter.selected : undefined,
          value: filter.selected !== 'undefined' && filter.selected !== undefined ? filter.ddData.filter(obj => obj.Key === filter.selected)[0].Optional : undefined
        };
        filterObj.push(f);
      } else {
        const f = {
          name: filter.name,
          value: filter.type === FilterTypes.checkbox ? filter.checked : (filter.selected !== 'undefined' && filter.selected !== undefined ? filter.selected : undefined)
        };
        filterObj.push(f);
      }
    }

    this.searchObjectService.setFilters(filterObj);
    this.searchObjectService.setSearchURL(true, searchType);
    // this.filtersAvailableChange.next(null);
  }

  updateFilterData(filter: ResultFilter, value: string) {
    if (filter.autoUpdateDD) {
      let newValue = value;

      if (value !== 'undefined' && value) {
        if (filter.name === FilterTerms.subProductKey) {
          newValue = filter.ddData.filter(obj => obj.Key === filter.selected)[0].Optional;
        }
      }

      const functionFilter = this.filters.filter(obj => obj.name === filter.autoUpdateDD);
      const updateFilter = this.filtersDisplay.filter(obj => obj.name === filter.autoUpdateDD);
      if (functionFilter.length > 0 && functionFilter[0].ddUpdate) {
        functionFilter[0].ddUpdate(this, updateFilter[0], newValue);
      }
    }
  }

  // SortTypeFilters Dropdown
  createSortFilter(more: boolean, prevDes: boolean) {
    const name = FilterTerms.sortType;
    const order = this.filterOrder.indexOf(name);
    const displayName = DisplayFilterTerms.sortType;
    const type = FilterTypes.dropdown;
    const selected = this.searchObjectService.getSearchObject().filters.sortType;
    const data: DDData[] = [new DDData(SortTypes.BestMatch, DisplayFilterTerms.BestMatch), new DDData(SortTypes.Distance, DisplayFilterTerms.Distance), new DDData(SortTypes.NameMatch, DisplayFilterTerms.NameMatch)];
    const moreViewMoreText = '';

    this.filters.push(new ResultFilter(order, more, prevDes, name, displayName, moreViewMoreText, false, type, selected, data));
  }

  createTeleHealthFilter(more: boolean, prevDes: boolean) {
    const name = FilterTerms.telehealth;
    const order = this.filterOrder.indexOf(name);
    const displayName = DisplayFilterTerms.telehealth;
    const type = FilterTypes.checkbox;
    const checked = this.searchObjectService.getSearchObject().filters.telehealth;
    const moreViewMoreText = '';

    this.filters.push(new ResultFilter(order, more, prevDes, name, displayName, moreViewMoreText, checked, type));
  }

  createPeoplePlacesFilter(more: boolean, prevDes: boolean) {
    const name = FilterTerms.peopleplaces;
    const order = this.filterOrder.indexOf(name);
    const displayName = DisplayFilterTerms.peopleplaces;
    const type = FilterTypes.checkboxlist;
    const peopleChecked = this.searchObjectService.getSearchObject().filters.people;
    const placesChecked = this.searchObjectService.getSearchObject().filters.places;
    const selected = peopleChecked || placesChecked;
    const moreViewMoreText = '';

    const data: DDData[] = [new DDData(FilterTerms.people, DisplayFilterTerms.people, null, peopleChecked), new DDData(FilterTerms.places, DisplayFilterTerms.places, null, placesChecked)];
    this.filters.push(new ResultFilter(order, more, prevDes, name, displayName, moreViewMoreText, null, type, selected, data));
  }

  createAcceptingFilter(more: boolean, prevDes: boolean) {
    const name = FilterTerms.acceptingNewPatients;
    const order = this.filterOrder.indexOf(name);
    const displayName = DisplayFilterTerms.acceptingNewPatients;
    const type = FilterTypes.checkbox;
    const checked = this.searchObjectService.getSearchObject().filters.acceptingNewPatients;
    const moreViewMoreText = '';

    this.filters.push(new ResultFilter(order, more, prevDes, name, displayName, moreViewMoreText, checked, type));
  }


  createOpenTimesFilter(more: boolean, prevDes: boolean) {
    const name = FilterTerms.opentime;
    const order = this.filterOrder.indexOf(name);
    const displayName = DisplayFilterTerms.opentime;
    const type = FilterTypes.checkboxlist;
    const eveningChecked = this.searchObjectService.getSearchObject().filters.eveningHours;
    const weekendChecked = this.searchObjectService.getSearchObject().filters.weekendHours;
    const selected = eveningChecked || weekendChecked;
    const moreViewMoreText = '';

    const data: DDData[] = [new DDData(FilterTerms.eveningHours, DisplayFilterTerms.eveningHours, null, eveningChecked), new DDData(FilterTerms.weekendHours, DisplayFilterTerms.weekendHours, null, weekendChecked)];
    this.filters.push(new ResultFilter(order, more, prevDes, name, displayName, moreViewMoreText, null, type, selected, data));
  }

  createHandicapFilter(more: boolean, prevDes: boolean) {
    const name = FilterTerms.handicapAccess;
    const order = this.filterOrder.indexOf(name);
    const displayName = DisplayFilterTerms.handicapAccess;
    const type = FilterTypes.checkbox;
    const checked = this.searchObjectService.getSearchObject().filters.handicapAccess;
    const moreViewMoreText = '';

    this.filters.push(new ResultFilter(order, more, prevDes, name, displayName, moreViewMoreText, checked, type));
  }

  createAccredFilter(more: boolean, prevDes: boolean) {
    const name = FilterTerms.accreditedFacility;
    const order = this.filterOrder.indexOf(name);
    const displayName = DisplayFilterTerms.accreditedFacility;
    const type = FilterTypes.checkbox;
    const checked = this.searchObjectService.getSearchObject().filters.accreditedFacility;
    const moreViewMoreText = '';

    this.filters.push(new ResultFilter(order, more, prevDes, name, displayName, moreViewMoreText, checked, type));
  }

  // ResultFilters Dropdown
  createGenderFilter(more: boolean, prevDes: boolean) {
    const name = FilterTerms.gender;
    const order = this.filterOrder.indexOf(name);
    const displayName = DisplayFilterTerms.gender;
    const type = FilterTypes.dropdown;
    const selected = this.searchObjectService.getSearchObject().filters.gender;
    const data: DDData[] = [new DDData(undefined, FilterTerms.Both), new DDData('Male', 'Male'), new DDData('Female', 'Female')];
    const moreViewMoreText = '';

    this.filters.push(new ResultFilter(order, more, prevDes, name, displayName, moreViewMoreText, false, type, selected, data));
  }

  createLanguageFilter(more: boolean, prevDes: boolean) {
    const name = FilterTerms.language;
    const order = this.filterOrder.indexOf(name);
    const displayName = DisplayFilterTerms.language;
    const type = FilterTypes.dropdown;
    const ddData: DDData[] = [];
    let selected = this.searchObjectService.getSearchObject().filters.language;
    const moreViewMoreText = '';

    if (this.filterData.languages && this.filterData.languages.length > 0) {
      for (const language of this.filterData.languages) {
        ddData.push(new DDData(language, language));
      }
    }

    if (ddData.length > 0) {
      if (!this.checkSelectedExists(selected, ddData)) {
        selected = undefined;
      }
      this.filters.push(new ResultFilter(order, more, prevDes, name, displayName, moreViewMoreText, false, type, selected, ddData));
    }
  }

  createHospitalPrivilegeFilter(more: boolean, prevDes: boolean) {
    const name = FilterTerms.hospitalPrivilege;
    const order = this.filterOrder.indexOf(name);
    const displayName = DisplayFilterTerms.hospitalPrivilege;
    const type = FilterTypes.dropdown;
    const ddData: DDData[] = [];
    const autoUpdateDD = null;
    const ddUpdate = this.updateHospitalPrivilegeFilter;
    const currSubKey = this.searchObjectService.getSearchObject().filters.subProductKey;
    let selected = this.searchObjectService.getSearchObject().filters.hospitalPrivilege;
    const moreViewMoreText = '';

    if (currSubKey) {
      let networkObj = [];
      networkObj = this.filterData.networks.filter(obj => obj.subProductKey == currSubKey);
      if (networkObj.length > 0) {
        for (const hospital of networkObj[0].hospitals) {
          ddData.push(new DDData(hospital, hospital));
        }
      }
    } else {
      if (this.filterData.hospitals && this.filterData.hospitals.length > 0) {
        for (const hospital of this.filterData.hospitals) {
          ddData.push(new DDData(hospital, hospital));
        }
      }
    }
    if (ddData.length > 0) {
      if (!this.checkSelectedExists(selected, ddData)) {
        selected = undefined;
      }
      this.filters.push(new ResultFilter(order, more, prevDes, name, displayName, moreViewMoreText, false, type, selected, ddData, autoUpdateDD, ddUpdate));
    }
  }

  updateHospitalPrivilegeFilter(_this: any, filter: ResultFilter, newSearchValue: string) {
    const ddData: DDData[] = [];

    if (newSearchValue && (newSearchValue !== 'undefined')) {
      let networkObj = [];
      networkObj = _this.filterData.networks.filter(obj => obj.subProductKey == newSearchValue);
      if (networkObj.length > 0) {
        for (const hospital of networkObj[0].hospitals) {
          ddData.push(new DDData(hospital, hospital));
        }
      }
    } else {
      if (_this.filterData.hospitals && _this.filterData.hospitals.length > 0) {
        for (const hospital of _this.filterData.hospitals) {
          ddData.push(new DDData(hospital, hospital));
        }
      }
    }

    if (ddData.length > 0) {
      if (!_this.checkSelectedExists(filter.selected, filter.ddData)) {
        filter.selected = undefined;
      }
      filter.ddData = ddData;
    }
  }

  createPlansAcceptedFilter(more: boolean, prevDes: boolean) {
    const name = FilterTerms.subProductKey;
    const order = this.filterOrder.indexOf(name);
    const displayName = DisplayFilterTerms.subProductKey;
    const type = FilterTypes.dropdown;
    const ddData: DDData[] = [];
    const autoUpdateDD = FilterTerms.hospitalPrivilege;
    const moreViewMoreText = DisplayFilterTerms.networksAccepted;

    let selected = this.searchObjectService.getPlanDisplayKey();
    let networks = this.filterData.networks.filter(o => o.shouldDisplay);

    if ((networks && networks.length === 1) || (networks.length > 0 && this.searchObjectService.getNetworkID() === '0000010000010001600002' && (networks[0].subProductKey == '205' || networks[1].subProductKey == '239'))) {
      if ((networks[0].subProductKey === this.searchObjectService.getSubProductKey()) || (networks[1].subProductKey === this.searchObjectService.getSubProductKey())) {
        return;
      }
    }

    if (networks && networks.length > 0) {
      const names = [];
      for (const p of networks) {
        // filter out planyear plans
        if (!names.includes(p.name)) { // don't add duplicate names
          if (this.searchObjectService.getSearchYear()) {
            if (p.shouldDisplay && (this.searchObjectService.getSearchYear() === p.planYear || p.planYear === undefined)) {
              const key = p.displayKey;
              ddData.push(new DDData(key, p.name, p.subProductKey));
              names.push(p.name);
            }
          } else {
            if (p.shouldDisplay) {
              const key = p.displayKey;
              ddData.push(new DDData(key, p.name, p.subProductKey));
              names.push(p.name);
            }
          }
        }
      }
      if (ddData.length > 0) {
        if (!this.checkSelectedExists(selected, ddData)) {
          selected = undefined;
        }
        this.filters.push(new ResultFilter(order, more, prevDes, name, displayName, moreViewMoreText, false, type, selected, ddData, autoUpdateDD));
      }
    }
  }

  // createLGBTQIAFilter(more: boolean, prevDes: boolean) {
  //   const name = FilterTerms.lgbtqia;
  //   const order = this.filterOrder.indexOf(name);
  //   const displayName = DisplayFilterTerms.lgbtqia;
  //   const type = FilterTypes.checkbox;
  //   const checked = this.searchObjectService.getSearchObject().filters.lgbtqia;
  //   const moreViewMoreText = '';

  //   this.filters.push(new ResultFilter(order, more, prevDes, name, displayName, moreViewMoreText, checked, type));
  // }
}


export class ResultFilter {

  constructor(order: number, more: boolean, prevDes: boolean, name: string, displayName: string, moreViewMoreText: string, checked: boolean, type: string,
    selected?: string, ddData?: DDData[], autoUpdateDD?: string, ddUpdate?: Function) {
    this.order = order;
    this.name = name;
    this.displayName = displayName;
    this.checked = checked;
    this.type = type;
    this.ddData = ddData;
    this.selected = selected;
    this.moreViewMoreText = moreViewMoreText;
    this.more = more;
    this.prevDes = prevDes;
    this.ddUpdate = ddUpdate;
    this.autoUpdateDD = autoUpdateDD;
    this.html = undefined;
    this.movetoMore = false;
  }

  order: number;
  name: string;
  checked: boolean;
  selected: string;
  type: string;
  ddData?: DDData[];
  ddUpdate?: Function;
  autoUpdateDD: string;
  prevDes: boolean;
  displayName: string;
  moreViewMoreText: string;
  more: boolean;
  showMoreAll = false;
  html: ElementRef;
  movetoMore: boolean;
}

class DDData {

  constructor(key: string, value: string, optional?: string, checked?: boolean) {
    this.Key = key;
    this.Value = value;
    this.Optional = optional;
    this.Checked = checked;
  }

  Key: string;
  Value: string;
  Optional?: string;
  Checked?: boolean;
}

